import React from 'react';
import classNames from 'classnames';
import './Accordion.scss';
import { Icons } from '../BootstrapComponents/BootstrapComponents';

export function Accordion(props) {
  const {
    title = '',
    content = '',
    variant = 'default',
    isOpen = false,
  } = props;

  const [toggle, setToggle] = React.useState(isOpen);

  const isSecondary = variant === 'secondary';

  return (
    <div className={classNames('accordion', { secondary: isSecondary })}>
      <div
        className={classNames('accordion-header', {
          'no-border': isSecondary && !toggle,
        })}
        onClick={() => setToggle(!toggle)}
      >
        {isSecondary ? (
          <>
            <div className="accordion-header-toggle">
              <Icons customIcon icon={toggle ? 'down' : 'up'} />
            </div>
            <div>{title}</div>
          </>
        ) : (
          <>
            <div>{title}</div>
            <Icons customIcon icon={toggle ? 'down' : 'up'} />
          </>
        )}
      </div>
      {toggle ? content : null}
    </div>
  );
}
